import { Tag } from "antd";
const helperFunctions = {
  getColor: function (value) {
    let colorClass = "zero_color";
    if (value == "1") {
      colorClass = "one_color";
    } else if (value == "2") {
      colorClass = "two_color";
    } else if (value == "3") {
      colorClass = "three_color";
    } else if (value == "4") {
      colorClass = "four_color";
    }
    return colorClass;
  },
  getColorForCpibForm: function (value) {
    let colorClass = "zero_color";
    if (value == "0") {
      colorClass = (
        <>
          <Tag className="tag-font-size-15" color="green">
            Very much
          </Tag>{" "}
          <span className="tag-font-size-15">(0)</span>
        </>
      );
    } else if (value == "1") {
      colorClass = (
        <>
          <Tag className="tag-font-size-15" color="cyan">
            Quite a bit
          </Tag>{" "}
          <span className="tag-font-size-15">(1)</span>
        </>
      );
    } else if (value == "2") {
      colorClass = (
        <>
          <Tag className="tag-font-size-15" color="purple">
            A little
          </Tag>{" "}
          <span className="tag-font-size-15">(2)</span>
        </>
      );
    } else if (value == "3") {
      colorClass = (
        <>
          <Tag className="tag-font-size-15" color="magenta">
            Not at all
          </Tag>{" "}
          <span className="tag-font-size-15">(3)</span>
        </>
      );
    }
    return colorClass;
  },
  get_road_text: function (value) {
    let text = "";
    if (value == "0") {
      text = "Unable to perform";
    } else if (value == "1") {
      text = "Abnormal: able to perform but with difficulty";
    } else if (value == "2") {
      text = "Normal: able to perform without difficulty";
    }
    return text;
  },
};

export default helperFunctions;
